// extracted by mini-css-extract-plugin
var _1 = "st0gS";
export { _1 as "base" }
